import { EffectCallback, useEffect } from 'react';

import useDeepCompareMemoize from './useDeepCompareMemoize';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useDeepCompareEffectForMaps = (callback: EffectCallback, dependencies: any[]): void =>
  useEffect(callback, dependencies.map(useDeepCompareMemoize));

export default useDeepCompareEffectForMaps;
